export const urlUser = 'https://pos-api.boldestore.com/image/user/';
export const urlProduct = 'https://pos-api.boldestore.com/image/product/';
export const urlOutlet = 'https://pos-api.boldestore.com/image/outlet/';
export const urlReceipt = 'https://pos-api.boldestore.com/image/receipt/';

// export const urlUser = 'http://localhost:8010/image/user/';
// export const urlProduct = 'http://localhost:8010/image/product/';
// export const urlOutlet = 'http://localhost:8010/image/outlet/';
// export const urlReceipt = 'http://localhost:8010/image/receipt/';